export interface CloneFormRequest {
  customFormId: string;
  targetTenantId: string;
  targetLibraryId: string;
  duplicateCustomFormBehaviour: number;
  duplicateFormLibraryBehaviour: number;
}

export interface CloneFormLibraryRequest {
  sourceLibraryId: string;
  targetTenantId: string;
  duplicateFormLibraryBehaviour: number;
}

export enum CloneCustomFormBehaviourEnum {
  ThrowIfDuplicate = 0,
  AddMigratedPrefix = 1,
  CopyAnyway = 2,
  Ignore = 3,
}
